import { ActionTypes as types } from '../constants';

const initialState = {
  data: {},
  isLoaded: false,
  isFetching: false,
  isAccessCodeSave: '',
  isEnabled: false,
  isToastOff: false,
};

type Action = {
  type: string;
  payload: string;
};

const mfa = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.SAVE_MFA_ACCESS_CODE:
      return { ...state, isAccessCodeSave: action.payload };
    case types.MFA_ENABLED:
      return { ...state, isEnabled: action.payload };
    case types.HIDE_SUCCESS_TOAST:
      return { ...state, isToastOff: action.payload };
    default:
      return state;
  }
};

export default mfa;
